import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "b-app-header__wrapper h-pos-rel qa-app-header"
}
const _hoisted_2 = { class: "b-app-header__inner" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ChooseSiteLang = _resolveComponent("ChooseSiteLang")!

  return (!_ctx.hideAppHeader)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (!_ctx.isTablet())
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["b-app-header__burger qa-app-header-burger", {"active": _ctx.showMenuMob}]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showMenuMob = !_ctx.showMenuMob))
              }, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("div", null, null, -1),
                _createElementVNode("div", null, null, -1),
                _createElementVNode("div", null, null, -1)
              ]))], 2))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, {
            to: "/",
            class: "b-app-header__aside-part qa-app-header-logo"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _ctx.requireImage(`${_ctx.mainLogo}.svg`)
              }, null, 8, _hoisted_3)
            ]),
            _: 1
          }),
          (_ctx.isUserAuth && !_ctx.hideLogout)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: { name: "LogOutPage" },
                class: "h-mh-30 qa-app-header-logout"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('LOG_OUT.TEXT')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.isUserAuth)
            ? (_openBlock(), _createBlock(_component_ChooseSiteLang, {
                key: 2,
                class: "h-ml-20 qa-app-header-lang-selector b-app-header__wrapper__select",
                onSetLang: _ctx.setStorageLocale
              }, null, 8, ["onSetLang"]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}